// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nwsa","tabsBox":"styles_tabsBox__1ZQTO","createButton":"styles_createButton__2CRpe"};